import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  RESET,
  GET_CITY_LIST_SUCCESS,
  GET_PROVINCE_LIST_SUCCESS,
  GET_COUNTRY_LIST_SUCCESS,
  GET_CLAIM_TYPES_SUCCESS,
  POLICY_VERSION_CHANGED,
  GET_COUNTRY_SUPPORTED_LIST_SUCCESS,
  TRIGGER_WHAT_HAPPENED_VALIDATION,
  TRIGGER_WHAT_HAPPENED_VALIDATION_SUCCESS,
  TRIGGER_WHAT_HAPPENED_VALIDATION_FAILURE,
  CLEAR_WHAT_HAPPENED_VALIDATION,
} from './constants';

import { mapDataForClaimType } from './mapDataForClaimType';
import { defaultCountry } from '../../FastCover/dataMapper/claimCodeMapper';

// The initial state of the App
const initialState = fromJS({
  form: {
    dateOfEvent: '',
    dateSymptomsStarted: '',
    timeOfEvent: null,
    country: defaultCountry && defaultCountry.id && defaultCountry.name ? {
            id: defaultCountry.id,
            label: defaultCountry.name,
            value: defaultCountry.name,
          } : null,
    selectedCountry: defaultCountry && defaultCountry.id && defaultCountry.name  ? {
            id: defaultCountry.id,
            label: defaultCountry.name,
            value: defaultCountry.name,
          } : null,
    city: null,
    province: '',
    storyEvent: '',
    // totalAmount: '',
    title: '',
    firstName: '',
    surName: '',
    dateOfBirth: '',
    relationshipToYou: '',
    dateYouFirstBecomeAware: '',
    detailOfMedicalCondition: '',
    dateBookedTrip: '',
    dateScheduledToDepart: '',
    dateOriginallyScheduled: '',
    selectedBenefits: [],
    selectedClaimFor: [],
    whatIsTheOutstandingDuesAmount: '',
    currency: '',
    // Tour Operator
    nameOfTheTourOperator: '',
    address: '',
    cityOrTown: '',
    countryTourOperator: '',
    postalCode: '',
    contact: '',
    phoneNumber: '',
    bookingReservationNumber: '',
    destinations: '',
    cityOfDeparture: '',
    returnDestination: '',
    dateOfInitialPaymentDesposit: '',
    ifNotIncludedInThePackage: '',
    usePrimaryMemberEmailAddressForAllMember: false,
    usePrimaryMemberPhoneNumberForAllMember: false,
    purposeOfTrip: '',
    whatHappenedValidationFeedback: null,
    whatHappenedValidationIsSufficient: null,
  },
  countryList: [],
  countriesOfxSupported: [],
  cityList: [],
  provinceList: [],
  claimTypeList: [],
  initClaimTypeList: [],
  oldEventDate: '',
  oldEventTime: null,
  policyVersionChanged: false,
  whatHappenedValidation: {
    isLoading: false,
    isSufficient: null,
    feedbackMessage: null,
  },
});

function stepWhatHappenedReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({
          form: action.payload,
          countryList: state.getIn(['countryList']),
          countriesOfxSupported: state.getIn(['countriesOfxSupported']),
          cityList: [],
          provinceList: state.getIn(['provinceList']),
          claimTypeList: state.getIn(['claimTypeList']),
          oldEventDate: action.payload.dateOfEvent,
          oldEventTime: action.payload.timeOfEvent,
          // Restore validation state from persisted form data if available
          whatHappenedValidation: (action.payload.whatHappenedValidationIsSufficient !== null && action.payload.whatHappenedValidationIsSufficient !== undefined)
            ? {
              isLoading: false,
              isSufficient: typeof action.payload.whatHappenedValidationIsSufficient === 'string'
                ? action.payload.whatHappenedValidationIsSufficient.toLowerCase() === 'true'
                : action.payload.whatHappenedValidationIsSufficient,
              feedbackMessage: action.payload.whatHappenedValidationFeedback || null,
            }
            : (state.getIn(['whatHappenedValidation']) || initialState.getIn(['whatHappenedValidation'])),
        })
        : initialState;
    case RESET:
      return initialState;
    case GET_COUNTRY_LIST_SUCCESS:
      return state.setIn(['countryList'], action.countries);
    case GET_COUNTRY_SUPPORTED_LIST_SUCCESS:
      return state.setIn(['countriesOfxSupported'], action.countries);
    case GET_CITY_LIST_SUCCESS:
      return state.setIn(['cityList'], action.cities);
    case GET_PROVINCE_LIST_SUCCESS:
      return state.setIn(['provinceList'], action.provinces);
    case GET_CLAIM_TYPES_SUCCESS:
      return state.setIn(['claimTypeList'], mapDataForClaimType(action.claimTypeList, action.policyTypeId, action.jsonVersion, action.showZurichUHC, action.policyTypeCode));
    case POLICY_VERSION_CHANGED:
      return state.setIn(['policyVersionChanged'], action.value);
    case TRIGGER_WHAT_HAPPENED_VALIDATION:
      return state.setIn(['whatHappenedValidation', 'isLoading'], true);
    case TRIGGER_WHAT_HAPPENED_VALIDATION_SUCCESS:
      return state.setIn(['whatHappenedValidation', 'isLoading'], false)
        .setIn(['whatHappenedValidation', 'isSufficient'], action.isSufficient)
        .setIn(['whatHappenedValidation', 'feedbackMessage'], action.feedbackMessage)
        // Persist feedback to form object for later retrieval
        .setIn(['form', 'whatHappenedValidationFeedback'], action.feedbackMessage)
        .setIn(['form', 'whatHappenedValidationIsSufficient'], action.isSufficient);
    case TRIGGER_WHAT_HAPPENED_VALIDATION_FAILURE:
      return state.setIn(['whatHappenedValidation', 'isLoading'], false);
    case CLEAR_WHAT_HAPPENED_VALIDATION:
      return state.setIn(['whatHappenedValidation', 'isLoading'], false)
        .setIn(['whatHappenedValidation', 'isSufficient'], null)
        .setIn(['whatHappenedValidation', 'feedbackMessage'], null)
        // Clear persisted feedback from form object
        .setIn(['form', 'whatHappenedValidationFeedback'], null)
        .setIn(['form', 'whatHappenedValidationIsSufficient'], null);
    default:
      return state;
  }
}

export default stepWhatHappenedReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepWhatHappened/reducer.js